// Domain configuration from bip-dash project
export const DOMAINS = [
  '411localnearmebiz.com',
  '411nearbylocalbiz.com',
  'areaexpertfinder.com',
  'best-near-me-local-biz.com',
  'bestareabizfinder.com',
  'bestbiznearby.com',
  'bestbusinessesinarea.com',
  'bestbusinesslist.com',
  'bestlocalbizguide.com',
  'bestlocalbiznearby.com',
  'bestlocalbiznearme.com',
  'bestlocalhelpers.com',
  'bestlocaloptionsnear.com',
  'bestlocalreviewsite.com',
  'bestlocalshopsnearme.com',
  'bestlocalsolutions.com',
  'bestnearbylocalbiz.com',
  'bestnearmecompanies.com',
  'bestnearmeguide.com',
  'bestnearmelocal.com',
  'bestnearmeplaces.com',
  'bestnearmeproviders.com',
  'bestofyourneighborhood.com',
  'bestplacestolocal.com',
  'biz411explorer.com',
  'biz411finder.com',
  'biz411hub.com',
  'biz411now.com',
  'bizaccesslocal.com',
  'bizbeaconnearme.com',
  'bizbuddynearme.com',
  'bizbuzznearme.com',
  'bizcatcher411.com',
  'bizconnect411.com',
  'bizconnectgo.com',
  'bizconnectline.com',
  'bizconnectlocally.com',
  'bizconnectplus.com',
  'bizconnectsearch.com',
  'bizexplorer411.com',
  'bizexplorersnearme.com',
  'bizfinddirectory.com',
  'bizfinderdirect.com',
  'bizfinderlink.com',
  'bizfindernearby.com',
  'bizfinderplus.com',
  'bizgo411.com',
  'bizguidebylocation.com',
  'bizguidefinder.com',
  'bizguideplus.com',
  'bizhomefinder.com',
  'bizhub411.com',
  'bizhubnearme.com',
  'bizhubplus.com',
  'bizhuntnearme.com',
  'bizhuntplus.com',
  'bizindex411.com',
  'bizlinkerhub.com',
  'bizlinknearme.com',
  'bizlocalonline.com',
  'bizlocatehub.com',
  'bizlocator411.com',
  'bizlocatorhub.com',
  'bizlocatorplus.com',
  'bizlookuphub.com',
  'bizmapnearme.com',
  'biznav411.com',
  'biznearbynow.com',
  'biznearhere.com',
  'biznearmefinder.com',
  'biznowfinder.com',
  'bizpulsefinder.com',
  'bizquickfinder.com',
  'bizroutelocal.com',
  'bizsearchhere.com',
  'bizsearchlink.com',
  'bizsearchnearby.com',
  'bizsearchpro.com',
  'bizsearchzone.com',
  'bizseekershub.com',
  'bizsnaplocal.com',
  'bizspot411.com',
  'bizspotnearme.com',
  'bizspotterlocal.com',
  'biztagnearme.com',
  'biztracker411.com',
  'biztrailnearme.com',
  'bizviewfinder.com',
  'bizzoneconnect.com',
  'bizzonefinder.com',
  'businessconnectnearme.com',
  'businessfinderlocal.com',
  'businesslocatornearme.com',
  'businessreviewsdirectory.com',
  'businessreviewsnearme.com',
  'citybiznearme.com',
  'cityguidebusiness.com',
  'cityservicereviews.com',
  'directorynearby.com',
  'directoryoflocals.com',
  'directoryofprofessionals.com',
  'directoryofservicelocals.com',
  'directoryoftrustedbiz.com',
  'explorelocalservices.com',
  'fastfindlocal.com',
  'findbestcitybiz.com',
  'findbestlocalbiznearby.com',
  'findbestnearbybiz.com',
  'findbiznearbynow.com',
  'findbusinessbyarea.com',
  'findbusinessbyzip.com',
  'findfastlocal.com',
  'findlocalpros411.com',
  'findlocalquick.com',
  'findlocalservicepros.com',
  'findlocalservicesnow.com',
  'findmebiz411.com',
  'findmebiznow.com',
  'findmylocalbiznearme.com',
  'findnearbiznow.com',
  'findnearbycompanies.com',
  'findnearme411.com',
  'findnearmebiz.com',
  'findnearmecompanies.com',
  'findnearmeexperts.com',
  'findnearmelocals.com',
  'findnearmeprofessionals.com',
  'findnearmestores.com',
  'findservicenear.com',
  'findservicesinarea.com',
  'findservicesnearme.com',
  'findtrustedbiz.com',
  'findtrustedlocals.com',
  'findtrustedvendors.com',
  'findurbiznearme.com',
  'findyourbizhub.com',
  'findyourcityservices.com',
  'findzipbiz.com',
  'localbizconnectnow.com',
  'localbizfinderonline.com',
  'localbizhubdirectory.com',
  'localbiznearbynow.com',
  'localbiznowsearch.com',
  'localbizping.com',
  'localbizranking.com',
  'localbizsearchnow.com',
  'localbiztrack.com',
  'localbizzone411.com',
  'localconnect411.com',
  'localcontractorlist.com',
  'localdirectorymap.com',
  'localdirectoryzone.com',
  'localexpertsnearby.com',
  'localfinderzone.com',
  'localgo2directory.com',
  'localnearme411.com',
  'localnearmedirectory.com',
  'localproreviewhub.com',
  'localprovidersnearme.com',
  'localrankingdirectory.com',
  'localreviewnetwork.com',
  'localsearchconnect.com',
  'localsearchnow.com',
  'localsearchplatform.com',
  'localsearchportal.com',
  'localservicebiznearme.com',
  'localservicesnearmenow.com',
  'localshop411finder.com',
  'localtopdirectory.com',
  'localvendorsnearby.com',
  'myfavlocalbiznearme.com',
  'myfavlocalbusiness.com',
  'myfavoritelocalbiznearme.com',
  'mylocal411finder.com',
  'mylocalservicedirectory.com',
  'mylocalstorehub.com',
  'mynearbiz.com',
  'mynearbizguide.com',
  'nearbizfinder.com',
  'nearbizmap.com',
  'nearbybizhub.com',
  'nearbybizspot.com',
  'nearbybizzone.com',
  'nearbybusinesssearch.com',
  'nearbylocalbiz.com',
  'nearbysmallbusiness.com',
  'nearbyspecialists.com',
  'nearbytopbusinesses.com',
  'nearmebizconnect.com',
  'nearmebizdirectory.com',
  'nearmebizfinder.com',
  'nearmebizreferral.com',
  'nearmebizreviews.com',
  'nearmebusinessfinder.com',
  'nearmebusinesshub.com',
  'nearmebusinesslist.com',
  'nearmebusinessreviews.com',
  'nearmecitydirectory.com',
  'nearmecompanylist.com',
  'nearmecontractors.com',
  'nearmeexpertfinder.com',
  'nearmeexpertreviews.com',
  'nearmeexpertsguide.com',
  'nearmefinders.com',
  'nearmeguidefinder.com',
  'nearmeguidehub.com',
  'nearmelocal411.com',
  'nearmelocalbizhub.com',
  'nearmelocalbizlist.com',
  'nearmelocalbusinesses.com',
  'nearmelocalconnect.com',
  'nearmelocaldeals.com',
  'nearmelocaldeals411.com',
  'nearmelocaldealsfinder.com',
  'nearmelocalfinderhub.com',
  'nearmelocalfinds.com',
  'nearmelocalgo.com',
  'nearmelocalguide411.com',
  'nearmelocallistings.com',
  'nearmelocalmap.com',
  'nearmelocalnow.com',
  'nearmelocalplace.com',
  'nearmelocalplus.com',
  'nearmelocalpros411.com',
  'nearmelocalsearchhub.com',
  'nearmelocalshopper.com',
  'nearmelocalshops.com',
  'nearmelocalspot.com',
  'nearmelocaltrack.com',
  'nearmelocalzone.com',
  'nearmeprofessionalhub.com',
  'nearmeprofessionals.com',
  'nearmeprosconnect.com',
  'nearmeshophub.com',
  'nearmeshoppingguide.com',
  'nearmeshoppro.com',
  'nearmeshopsearch.com',
  'nearmestoreconnect.com',
  'nearmestorefinder.com',
  'nearmestorehub.com',
  'nearmestoremap.com',
  'nearmestoresonline.com',
  'nearmetrustedbiz.com',
  'nearmevendors.com',
  'nearmevendorsearch.com',
  'quickbizfind.com',
  'quicklocalfinder.com',
  'reliablelocalbiz.com',
  'reviewednearme.com',
  'searchbiznearme.com',
  'searchlocalexperts.com',
  'searchtrustedbiz.com',
  'searchtrustedlocals.com',
  'servicedirectorynearme.com',
  'servicefinderlocal.com',
  'shopconnectnearme.com',
  'shopfindermap.com',
  'shopfindnearme.com',
  'shoplocalbiznearme.com',
  'shoplocallynow.com',
  'shoplocalnearmeguide.com',
  'shoplocalonlinefinder.com',
  'shopmap411.com',
  'shopmapnearme.com',
  'shopnearmehub.com',
  'shopspot411.com',
  'smallbusinessnearmedirectory.com',
  'supportlocalfinder.com',
  'toplocalbusinesses.com',
  'toplocalcompanylist.com',
  'topnearbusiness.com',
  'topnearmebiz.com',
  'topproviderslocal.com',
  'toprankedlocals.com',
  'topratedbizfinder.com',
  'topratedlocalservices.com',
  'topratedserviceproviders.com',
  'topratedsmallbusiness.com',
  'topservicefinder.com',
  'topservicerecommendations.com',
  'trustedareaexperts.com',
  'trustedbizdirectory.com',
  'trustedbizlocator.com',
  'trustedbusinessnearme.com',
  'trustedexpertsnearme.com',
  'trustedshopsnearme.com',
  'verifiedlocalexperts.com',
  'verifiedlocalservices.com',
  'verifiedservicefinder.com',
  'verifiedservicesnearme.com',
  'verifiedvendorsnearme.com',
  'yourareabusiness.com',
  'yourbiznearme.com',
  'yourcitybizfinder.com',
  'yourlocalfinder.com',
  'yourlocalreviewguide.com',
  'zipbizfinder.com',
  'zipbusinessdirectory.com',
  'zipcodedirectorysearch.com',
  'zipcodelocaldirectory.com',
  'bestway2get.com'
];

export const DOMAIN_COUNT = DOMAINS.length;
export const BATCH_SIZE = 10;
export const DELAY_BETWEEN_POSTS = 3000;
export const MAX_EXECUTION_TIME = 5 * 60 * 1000;
